<template>
    <div class="footer-area-wrapper" :class="FooterStyle">

        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 text-center">
                        <span class="copyright-text ">© {{new Date().getFullYear()}} {{i18n('footer.msg')}} <a href="https://www.runprof.com/" target="_blank" class="hover-style-link hover-style-link--green"> {{i18n('footer.comp')}} </a></span>
                    </div>
                    <!-- <div class="col-md-6 text-center ">
                        <ul class="list ht-social-networks solid-rounded-icon">
                            <li class="item">
                                <a href="#" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="#" target="_blank" class="social-link"> <i class="fab fa-twitter social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="#" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>
                            </li>
                        </ul>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"],
        methods : {
                    i18n(key, args) {
      return this.$t(key, args);
    },
        }        
    }
</script>
<style scoped>


</style>